<template>
    <div>
        <ul class="flex flex-col flex-wrap items-center justify-start w-full max-w-screen-lg px-4 mx-auto mt-12 md:flex-row">
            <li v-for="region in regions" :key="region.id" class="flex flex-col items-center justify-center w-3/12 p-4 text-center">
                <a :href="`/region/${region.id}`">
                    <p class="pt-4 text-lg font-semibold">{{ region.name }} </p>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props:[
            'regions'
        ],
    }
</script>